import carrinhoCompraRouters from './carrinho-compra';

export default [
  ...carrinhoCompraRouters,
  {
    path: '/produtos/:codMarca/catalogo-marca',
    name: 'produtos-catalogo-marca',
    component: () => import('@/views/app/CartECommerce/catalogo-produtos/ProdutosPorMarca.vue'),
    meta: {
      action: 'visualizar',
      resource: 'CatalogoProdutos',
    },
  },
  {
    path: '/grade-item/:familiaComercialId/:codMarca/:codCategoria',
    name: 'produtos-catalogo-grade-item',
    component: () => import('@/views/app/CartECommerce/catalogo-produtos/GradeItem.vue'),
    meta: {
      action: 'visualizar',
      resource: 'CatalogoProdutos',
    },
  },
];
